
    import { makeI18n } from '@/services/i18n';
    const baseTranslation = undefined
    
    
    if(module.hot) {
      const bucket = require("/app/build/i18n/browser-bucket.js");
      bucket.add('src/modules/registration/components/PersonalPresentationForm/ModalForm.vue', {"first_name":{"ru_RU":"Ваше имя","en_US":"First name"},"last_name":{"ru_RU":"Ваша Фамилия","en_US":"Last name"},"company":{"ru_RU":"Название компании","en_US":"Company name"},"phone":{"ru_RU":"Телефон","en_US":"Phone number"},"email":{"ru_RU":"Ваша эл. почта","en_US":"Email"},"email_repeat":{"ru_RU":"Повторите вашу эл. почту","en_US":"Email"},"position":{"ru_RU":"Ваша должность","en_US":"Job title"},"recruiters_amount":{"ru_RU":"Число рекрутеров","en_US":"Number of recruiters"},"agency":{"ru_RU":"Кадровое агентство","en_US":"Recruitment Agency"},"internal":{"ru_RU":"Внутренний HR","en_US":"In-House HR"},"software":{"ru_RU":"В чем ведете базу резюме сейчас","en_US":"What you're keeping your resume database in now"},"submit":{"ru_RU":"Заказать презентацию","en_US":"Request a presentation"},"consent":{"ru_RU":"Отправляя форму, я&nbsp;даю согласие на&nbsp;обработку перс. данных в&nbsp;соответствии с&nbsp;","en_US":"By submitting this form, I consent to the processing of my personal data in accordance with Huntflow's"},"consent.link":{"ru_RU":"Политикой&nbspконфиденциальности","en_US":"privacy&nbsppolicy"},"error.too_freq":{"ru_RU":"Слишком много запросов","en_US":"Too many requests"}}) 
    }
   
    
    export default function (Component) {
      function beforeCreateI18n() {
        this.$i18n = this.$options._i18n;
      }

      function addHook(current) {
        if (Array.isArray(current)) {
          return [beforeCreateI18n].concat(current);
        } 
        if (current) {
          return [beforeCreateI18n, current];
        }
        return [beforeCreateI18n];
      }
    
      Component._i18n = makeI18n("src/modules/registration/components/PersonalPresentationForm/ModalForm.vue", baseTranslation);
      Component.beforeCreate = addHook(Component.beforeCreate);
      delete Component._Ctor;
    }
  